import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import WorkspaceFormInput from 'workspace/WorkspaceFormInput'
import { changeFormData } from 'workspace/actions'

const WorkspaceFormRemarks = ({ remarks, onChange }) => (
  <WorkspaceFormInput attribute='remarks'>
    <input
      type='text'
      className='workspace-form__input'
      value={remarks}
      onChange={(e) => onChange({ remarks: e.target.value })}
    />
  </WorkspaceFormInput>
)

WorkspaceFormRemarks.propTypes = {
  remarks: PropTypes.string,
  onChange: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  remarks: state.form.data.remarks
})

const mapDispatchToProps = ({
  onChange: changeFormData
})

export default connect(mapStateToProps, mapDispatchToProps)(WorkspaceFormRemarks)
